// import { handleActions } from 'redux-actions';
import * as User from '../../constants/User/Show';

const initialState = {
  selectedUser: null,
  loadError: false,
  usersCommunities: null,
  profileLoaded: false,
  communityLoaded: false
}


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case User.USER_INFO_GET:
      // console.log('sign_in', state, action)
      return state;
    case User.USER_INFO_GET_RESET:
      return {
        selectedUser: null,
        loadError: false,
        usersCommunity: null,
        profileLoaded: false,
        communityLoaded: false
      }
    case User.USER_INFO_GET_RESULT:
      if (action.response === false) {
        return Object.assign({}, state, {
          loadError: true,
          profileLoaded: true
        })
      } else {
        return Object.assign({}, state, {
          selectedUser: action.response,
          loadError: false,
          profileLoaded: true
        })
      }
    case User.USER_COMMUNITY_GET_RESULT:
      if (action.response === false) {
        return Object.assign({}, state, {
          loadError: true,
          communityLoaded: true
        })
      } else {
        return Object.assign({}, state, {
          usersCommunities: action.response,
          loadError: false,
          communityLoaded: true
        })
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/Show.js